import { Typography } from '@navi/web-ui/lib/primitives';
import BackIcon from '@cp/src/assets/images/icons/BackIcon';
import styles from './index.module.scss';
import cx from 'classnames';
import AllocationDetails from './AllocationDetails';
import { navigate } from '@cp/src/utils/ApiHelper';

const PreviousAllocation = () => {
  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col h-full">
      <div className={cx(styles.topNavContainer, 'gap-3')}>
        <BackIcon className="cursor-pointer" size={'16'} onClick={goBack} />
        <Typography variant="h2" color="var(--light-grayscale-content-2)">
          Previous allocation
        </Typography>
      </div>
      <div className="flex flex-1 items-center justify-center">
        <AllocationDetails />
      </div>
    </div>
  );
};

export default PreviousAllocation;
